import * as React from "react";
import { Box, Typography } from "@mui/material";
import { ImagesContext } from "../../Context";
import CustomChip from "../CustomChip";

interface Props {
  payer: string;
}

const Payer: React.FC<Props> = ({ payer }) => {
  const images = React.useContext(ImagesContext);

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: "4px",
      }}
    >
      <Box className="claim-step-two-list-tile">
        <Box
          sx={{
            display: "flex",
            columnGap: "16px",
            alignItems: "center",
          }}
        >
          <div className="item-icon-container">
            <img
              src={payer ? images.check_mark_icon : images.close_icon}
              alt="Insurance Icon"
              className="action-icon-image"
              style={{ width: 23, maxHeight: 23 }}
            />
          </div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              rowGap: "10px",
            }}
          >
            <Box display="flex" alignItems="center" columnGap="16px">
              <Typography
                sx={{
                  fontSize: "18px",
                  lineHeight: "18px",
                  fontWeight: 700,
                  letterSpacing: "1px",
                  color: "#4A4442",
                }}
              >
                Payer
              </Typography>
              {payer ? (
                <CustomChip label="No Errors" />
              ) : (
                <CustomChip label="Missing Payer" type="error" />
              )}
            </Box>
            {payer && (
              <Typography
                sx={{
                  fontSize: "14px",
                  lineHeight: "18px",
                  fontWeight: 500,
                  letterSpacing: "1px",
                  color: "#707070",
                }}
              >
                {payer}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Payer;
